import { startOfDay } from "date-fns";

type DateRange = [Date | null, Date | null];

// Constantes
export const TODAY = startOfDay(new Date());
export const DEFAULT_RANGE: DateRange = [null, null];

// Helpers
const isValidDate = (value: unknown): value is Date =>
  value instanceof Date && !Number.isNaN(value.getTime());

const convertToDateOrNull = (value: unknown): Date | null =>
  isValidDate(value) ? value : null;

export const sanitizeRange = (rawRange?: unknown[]): DateRange => {
  const [rawStartDate, rawEndDate] = Array.isArray(rawRange) ? rawRange : [];
  const startDate = convertToDateOrNull(rawStartDate);
  const endDate = convertToDateOrNull(rawEndDate);
  return [startDate, endDate];
};

const isSameDate = (dateA?: Date | null, dateB?: Date | null): boolean =>
  dateA === dateB ||
  (!!dateA && !!dateB && dateA.getTime() === dateB.getTime());

export const sameRange = (rangeA: DateRange, rangeB: DateRange): boolean =>
  isSameDate(rangeA[0], rangeB[0]) && isSameDate(rangeA[1], rangeB[1]);
